import { FC, SVGAttributes } from 'react';

const UploadedFileFormat: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg
            width="24"
            height="32"
            viewBox="0 0 24 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.2002 0.75H15.5107C16.325 0.75 17.1103 1.05564 17.71 1.60645L22.1982 5.72949C22.8683 6.34498 23.25 7.21318 23.25 8.12305V28.7998C23.25 30.1529 22.1529 31.25 20.7998 31.25H3.2002C1.8471 31.25 0.75 30.1529 0.75 28.7998V3.2002C0.75 1.8471 1.8471 0.75 3.2002 0.75Z"
                stroke="#E1DCD0"
                strokeWidth="1.5"
            />
            <mask id="path-2-inside-1_17720_79924" fill="white">
                <path d="M16 0.800781H22.8V7.60078H16.8C16.3582 7.60078 16 7.24261 16 6.80078V0.800781Z" />
            </mask>
            <path
                d="M16 0.800781H22.8H16ZM22.8 9.10078H16.8C15.5297 9.10078 14.5 8.07104 14.5 6.80078L17.5 6.10078H22.8V9.10078ZM16.8 9.10078C15.5297 9.10078 14.5 8.07104 14.5 6.80078V0.800781H17.5V6.10078L16.8 9.10078ZM22.8 0.800781V7.60078V0.800781Z"
                fill="#E1DCD0"
                mask="url(#path-2-inside-1_17720_79924)"
            />
        </svg>
    );
};

export default UploadedFileFormat;
